var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedDs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1989_78177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4395 0H6.5C5.70435 0 4.94129 0.316071 4.37868 0.87868C3.81607 1.44129 3.5 2.20435 3.5 3V21C3.5 21.7956 3.81607 22.5587 4.37868 23.1213C4.94129 23.6839 5.70435 24 6.5 24H18.5C19.2956 24 20.0587 23.6839 20.6213 23.1213C21.1839 22.5587 21.5 21.7956 21.5 21V7.0605C21.4999 6.66271 21.3418 6.28124 21.0605 6L15.5 0.4395C15.2188 0.158176 14.8373 8.49561e-05 14.4395 0V0ZM14.75 5.25V2.25L19.25 6.75H16.25C15.8522 6.75 15.4706 6.59196 15.1893 6.31066C14.908 6.02936 14.75 5.64782 14.75 5.25ZM5 13.5H20V15H9.5V18H20V19.5H9.5V22.5H8V19.5H5V18H8V15H5V13.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1989_78177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedDs);
export default __webpack_public_path__ + "static/media/UploadedDS.4126299e0c629372170940650ef5ba29.svg";
export { ForwardRef as ReactComponent };